import type { KnownUnit } from './unit'

type Cancelled = { type: 'Cancelled' }
type Success = { type: 'Success'; unit: KnownUnit }
type Redirect = { type: 'Redirect'; path: string }
type NotFound = { type: 'NotFound' }
export type BarcodeResult = Cancelled | Success | NotFound | Redirect

export const cancelled: () => Cancelled = () => ({ type: 'Cancelled' })
export const success: (unit: KnownUnit) => Success = (unit) => ({ type: 'Success', unit })
export const notFound: () => NotFound = () => ({ type: 'NotFound' })
export const redirect: (path: string) => Redirect = (path: string) => ({ type: 'Redirect', path })
